module.exports = __webpack_public_path__ + "img/imagen.8eec7fa1.jpeg";